// extracted by mini-css-extract-plugin
var _1 = "H8gvf";
export { _1 as "tabs" }
